import type { WorkingTreeChangeRepoDetail, WorkingTreeRepoChangesBasis } from '../../../git/changes/index.js';
import { normalizeRepoPathRelativeToWorkspaceRoot } from '../../../git/changes/repo/normalize-repo-path-relative-to-workspace-root.js';

export type SessionGitListChangesOpts = {
  repoRelPath?: string;
  basis?: WorkingTreeRepoChangesBasis;
  recentCommitsLimit?: unknown;
};

const listChangesInflight = new Map<string, Promise<WorkingTreeChangeRepoDetail[]>>();

function normalizeListChangesRepoPathRelativeToWorkspaceRoot(repoRelPath?: string): string {
  if (!repoRelPath?.trim()) return '';
  return normalizeRepoPathRelativeToWorkspaceRoot(repoRelPath.trim());
}

function listChangesInflightKey(sessionId: string, opts?: SessionGitListChangesOpts): string {
  const basis = opts?.basis;
  return [
    sessionId,
    normalizeListChangesRepoPathRelativeToWorkspaceRoot(opts?.repoRelPath),
    basis?.kind === 'commit' ? `commit:${basis.sha}` : 'working',
    String(opts?.recentCommitsLimit ?? ''),
  ].join('|');
}

export function getSessionWorkingTreeChangeDetailsCoalesced(
  sessionWorktreeManager: {
    getSessionWorkingTreeChangeDetails: (
      sessionId: string,
      opts?: SessionGitListChangesOpts,
    ) => Promise<WorkingTreeChangeRepoDetail[]>;
  },
  sessionId: string,
  opts?: SessionGitListChangesOpts,
): Promise<WorkingTreeChangeRepoDetail[]> {
  const key = listChangesInflightKey(sessionId, opts);
  const existing = listChangesInflight.get(key);
  if (existing) return existing;
  const promise = sessionWorktreeManager
    .getSessionWorkingTreeChangeDetails(sessionId, opts)
    .finally(() => {
      if (listChangesInflight.get(key) === promise) listChangesInflight.delete(key);
    });
  listChangesInflight.set(key, promise);
  return promise;
}
